export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/arrow-right.49f48a14-6a4e8c.svg";